import { CRM_API, RequestHelper } from "utils";

export const CompaniaService = (() => {
  const buscarPorId = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(`compania/${Id}`);
    });
  };

  const actualizar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles("compania", data);
    });
  };

  const bloquearCancelarCompania = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/BloquearCancelarCompania", data);
    });
  };

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("compania", params);
    });
  };

  const listarHijas = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("compania/ListarHijas", params);
    });
  };

  const crear = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/CrearCompania", data);
    });
  };

  const editar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/EditarCompania", data);
    });
  };

  const editarVinculada = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/EditarCompaniaVinculada", data);
    });
  };

  const listarDatosCertificado = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).get("compania/ListarDatos", data);
    });
  };

  const vincularCuentaQuickbooks = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/VincularCuentaQuickbooks", data);
    });
  };

  const devincularCuentaQuickbooks = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post("compania/DesvincularCuentaQuickbooks", data);
    });
  };

  const desvincularQuickbooksPorRealmId = function (realmId) {
    return new Promise((res) => res(realmId)).then((id) => {
      return RequestHelper(CRM_API).get("compania/DesvincularCuentaQuickbooksPorRealmId", { realmId: id });
    });
  };


  const obtenerURLQuickbooks = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).get("compania/ObtenerURLQuickbooks", data);
    });
  };

  const ObtenerInformacionCuentaQuickbooks = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).get("compania/ObtenerInformacionCuentaQuickbooks", data);
    });
  };

  const crearEnProduccion = function (id, forzarIdAutomatico = false) {
    return new Promise((res) => res(id)).then((id) => {
      const url = forzarIdAutomatico
        ? `compania/CrearEnProduccion/${id}?forzarIdAutomatico=true`
        : `compania/CrearEnProduccion/${id}`;
      return RequestHelper(CRM_API).post(url);
    });
  };

  const exportarExcel = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`compania/ExportarExcel`, params, true);
    });
  };

  return {
    actualizar,
    bloquearCancelarCompania,
    buscarPorId,
    listado,
    listarHijas,
    editar,
    editarVinculada,
    crear,
    crearEnProduccion,
    listarDatosCertificado,
    vincularCuentaQuickbooks,
    obtenerURLQuickbooks,
    ObtenerInformacionCuentaQuickbooks,
    devincularCuentaQuickbooks,
    desvincularQuickbooksPorRealmId,
    exportarExcel
  };
})();
